import React, { useEffect, useState } from 'react'
import Header from '../../layouts/Header';
import { Alert, Button, Card, Col, Form, Image, InputGroup, Modal, Row, Spinner, Tab, Tabs } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from '../../api/axios';
import { Box, Truck } from 'react-bootstrap-icons';
import { useSelector } from 'react-redux';

const Settings = () => {

    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);
    const { access } = useSelector((state) => state.login);
    const { email } = useSelector((state) => state.login);
    const [systemAccess, setSystemAccess] = useState([]);
    
    console.log("Access :", access);
    
    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("Settings:")
            );
            setSystemAccess(filteredAccess);
        } 
    }, [access]);
    
    console.log("System Access:", systemAccess);

    const accessToken = localStorage.getItem("authToken");
    const [settingsData, setSettingsData] = useState({});
    const [currentImageKey, setCurrentImageKey] = useState('');
    const [openUpdateImgModal, setOpenUpdateImgModal] = useState(false);
    const [arrivalTime, setArrivalTime] = useState("");
    const [orderPickupArrivalTime , setOrderPickupArrivalTime ] = useState("");
    const [chargesForm, setChargesForm] = useState({
        deliveryCharges: '',
        packagingCharges: '',
        packagingTaxPercent: '',
        platformFees: '',
        platformTaxPercent: '',
        loadPerOrder: '',
        perItemFactor: '',
    });
    const [notificationImages, setNotificationImages] = useState({
        notificationImages: {
            accountCreation: null,
            inviteeAccountCreation: null,
            referralReward: null,
            orderPlaced: null,
            orderCancelled: null,
            orderDelivered: null,
            orderReady: null,
            orderStatusMismatchScan: null,
            outletOrderMismatchScan: null
        },
        _id: ''
    });
    const [imageError, setImageError] = useState('');
    const [couponsData, setCouponsData] = useState([]);
    const [bithdayCouponList, setBithdayCouponList] = useState([]);
    const [referralCouponList, setReferralCouponList] = useState([]);
    const [whatsAppCouponList, setWhatsAppCouponList] = useState([]);

    const [chargesBtnLoading, setChargesBtnLoading] = useState(false);
    const [ATBtnLoading, setATBtnLoading] = useState(false);
    const [CouponsBtnLoading, setCouponsBtnLoading] = useState(false);
    const [imageBtnLoading, setImageBtnLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('notificationImages');

    const [orderModeLoading, setOrderModeLoading] = useState(false);
    const [orderModes, setOrderModes] = useState({
        _id: "fsfgyuf66ybnqb89rq7",
        selfPickUp: "ACTIVE",
        delivery: "INACTIVE"
    });

    const getSettings = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }
            const response = await axios.get('settings', { headers });
            console.log("Response :", response);
            
            setSettingsData(response.data?.data?.settings);
            let charges = {
                deliveryCharges: response.data?.data?.settings?.deliveryCharges,
                packagingCharges: response.data?.data?.settings?.packagingCharges,
                packagingTaxPercent: response.data?.data?.settings?.packagingTaxPercent,
                platformFees: response.data?.data?.settings?.platformFees,
                platformTaxPercent: response.data?.data?.settings?.platformTaxPercent,
                loadPerOrder: response.data?.data?.settings?.loadPerOrder,
                perItemFactor: response.data?.data?.settings?.perItemFactor,
                _id: response.data?.data?.settings?._id,
            }
            let arrivalT = {
                _id: response.data?.data?.settings?._id,
                arrivalTimeSettings: response?.data?.data?.settings?.arrivalTimeSettings,
                orderPickupArrivalTime: response?.data?.data?.settings?.orderPickupArrivalTime
            }
            setChargesForm(charges);
            setArrivalTime(arrivalT);
            setOrderModes({
                delivery: response?.data?.data?.settings?.delivery,
                selfPickUp: response?.data?.data?.settings?.selfPickup
            })
        } catch (error) {
            console.error("Error fetching settings", error);
        }
    }

    const handleChangeCharges = (e) => {
        const { name, value } = e.target;
        setChargesForm({
            ...chargesForm,
            [name]: value
        })
    }

    const handleChargesSubmit = async (e) => {
        e.preventDefault();
        setChargesBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'multipart/form-data'
            };
            const response = await axios.put('settings', chargesForm, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getSettings();
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (error.response?.status === 406) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setChargesBtnLoading(false);
        }
    }

    const handleChangeArrivalTime = (e) => {
        const { name, value } = e.target;
        setArrivalTime(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    const handleArrivalTimeSubmit = async (e) => {
        e.preventDefault();
        setATBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'multipart/form-data'
            }
            const response = await axios.put("settings", arrivalTime, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getSettings();
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (error.response?.status === 406) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setATBtnLoading(false);
        }
    }

    const getCoupons = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }
            const response = await axios.get("coupons/getBirthdayReferralCoupon", { headers });
            setCouponsData(response?.data?.data?.coupons);
            const responseData = response?.data?.data?.coupons;
            console.log("All Coupons List :", responseData);
            
            const refCoupons = responseData.filter(c => c?.isBirthDayCoupon === false && c?.usageType === "MULTIPLE");
            console.log("Refferral COupon List :", refCoupons);
            
            const bdayCoupons = responseData.filter(c => c?.isReferralCoupon === false && c?.usageType === "MULTIPLE");
            console.log("Bday Coupon :", bdayCoupons);  
            
            const whatsappCoupon = responseData.filter(c => c?.isReferralCoupon === false && c?.usageType !== "MULTIPLE");
            console.log(" whatsApp Coupon list :", whatsappCoupon);
            
            setBithdayCouponList(bdayCoupons);
            setWhatsAppCouponList(whatsappCoupon);
            setReferralCouponList(refCoupons);
        } catch (error) {
            console.error("Error fetching settings", error);
        }
    }

    const imageLabels = {
        accountCreation: 'Account Creation',
        inviteeAccountCreation: 'Invitee Account Creation',
        referralReward: 'Referral Reward',
        orderPlaced: 'Order Placed',
        orderCancelled: 'Order Cancelled',
        orderDelivered: 'Order Delivered',
        orderReady: 'Order Ready',
        orderStatusMismatchScan: 'Order Status Mismatch On Scan',
        outletOrderMismatchScan: 'Outlet Order Mismatch On Scan',
        birthdayCouponNotUsed: 'Unused Birthday Coupon Image'
    }

    const handleInputChangeReff = (e) => {
        const { value } = e.target;
        setSettingsData((prevData) => ({
            ...prevData,
            referralCoupon: {
                ...prevData.referralCoupon,
                _id: value
            }
        }))
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSettingsData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    
    const handleWhatsAppCouponChange = (selectedCoupon) => {
        setSettingsData((prevData) => ({
            ...prevData,
            whatsAppCoupon: selectedCoupon,
        }));
    };

    const handleBirthCouponChange = (e) => {
        const { value } = e.target;
        setSettingsData((prevData) => ({
            ...prevData,
            couponInfo: {
                ...prevData.couponInfo,
                coupon: {
                    ...prevData.couponInfo?.coupon,
                    _id: value,
                },
            },
        }));
    };
    
    const handleSubmitCoupon = async (e) => {
        e.preventDefault();
        setCouponsBtnLoading(true);
        try {
            console.log("Debugging settingsData:", settingsData);
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'multipart/form-data'
            }
            const whatsAppCouponId = typeof settingsData?.whatsAppCoupon === "object" ? settingsData?.whatsAppCoupon._id : settingsData?.whatsAppCoupon;
            const formdata = new FormData();
            formdata.append('_id', settingsData?._id);
            formdata.append('referralCoupon', settingsData?.referralCoupon?._id);
            formdata.append('whatsAppCoupon', whatsAppCouponId);
            formdata.append('couponInfo[coupon]', settingsData?.couponInfo?.coupon?._id);
            const response = await axios.put("settings", formdata, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getSettings();
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (error.response?.status === 406) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                } else if (error.response?.status === 404) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setCouponsBtnLoading(false);
        }
    }

    const openImageModal = (key) => {
        setCurrentImageKey(key);
        setOpenUpdateImgModal(true);
    }

    const handleImageChange = (e, key) => {
        const file = e.target.files[0];
        if (file) {
            const validFormats = ['image/png', 'image/jpeg', 'image/jpg'];
            if (!validFormats.includes(file.type)) {
                setImageError('Invalid file format. Only JPEG, PNG, and JPG are allowed.');
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => {
                const img = new window.Image();
                img.onload = () => {
                    if (img.width === 500) {
                        setNotificationImages((prevImages) => ({
                            ...prevImages,
                            [key]: file
                        }));
                        setImageError('');
                    } else {
                        setImageError('Image width must be 500px');
                    }
                };
                img.src = event.target.result;
            };
            reader.readAsDataURL(file);
        }
    };

    const handleUpdateImages = async (e) => {
        e.preventDefault();
        setImageBtnLoading(true);
        const updatedImages = {
            accountCreation: notificationImages.accountCreation || settingsData?.notificationImages?.accountCreation || null,
            inviteeAccountCreation: notificationImages.inviteeAccountCreation || settingsData?.notificationImages?.inviteeAccountCreation || null,
            referralReward: notificationImages.referralReward || settingsData?.notificationImages?.referralReward || null,
            orderPlaced: notificationImages.orderPlaced || settingsData?.notificationImages?.orderPlaced || null,
            orderCancelled: notificationImages.orderCancelled || settingsData?.notificationImages?.orderCancelled || null,
            orderDelivered: notificationImages.orderDelivered || settingsData?.notificationImages?.orderDelivered || null,
            orderReady: notificationImages.orderReady || settingsData?.notificationImages?.orderReady || null,
            orderStatusMismatchScan: notificationImages.orderStatusMismatchScan || settingsData?.notificationImages?.orderStatusMismatchScan || null,
            outletOrderMismatchScan: notificationImages.outletOrderMismatchScan || settingsData?.notificationImages?.outletOrderMismatchScan || null,
            birthdayCouponNotUsed: notificationImages.birthdayCouponNotUsed || settingsData?.notificationImages?.birthdayCouponNotUsed || null
        };
        const _id = settingsData?._id;
        setNotificationImages(updatedImages);
        try {
            const headers = {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${accessToken}`,
            };
            const formData = new FormData();
            formData.append("_id", _id);
            for (const key in updatedImages) {
                if (updatedImages[key]) {
                    formData.append(`notificationImages.${key}`, updatedImages[key]);
                }
            }
            const response = await axios.put("settings", formData, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                getSettings();
                setOpenUpdateImgModal(false);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = "";
                if (error.response?.status === 406) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
                } else if (error.response?.status === 400) {
                    errorMessage = error?.response?.data?.message;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        } finally {
            setImageBtnLoading(false);
        }
    };

    const handleOrderModeChange = (e) => {
        const { name, value } = e.target;
        setOrderModes((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleOrderModeSubmit = async (e) => {
        e.preventDefault();
        setOrderModeLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }
            let id = settingsData?._id;
            let del = orderModes?.delivery;
            let pickup = orderModes?.selfPickUp;
            const response = await axios.put(`settings/updateStatus?_id=${id}&delivery=${del}&selfPickup=${pickup}`, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getSettings();
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (error.response?.status === 406) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setOrderModeLoading(false);
        }
    };

    useEffect(() => {
        getSettings();
        getCoupons();
    }, []);

    if (!settingsData) {
        return <div className="d-flex justify-content-center mt-5">
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>;
    }

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
                <div className="main main-app p-3 p-lg-4">
                    <div
                        className="container shadow-sm"
                        style={{ backgroundColor: "white" }}
                    >
                        <Row className='pt-4 '>
                            <Col>
                                <h5 className="fw-semibold">SYSTEM SETTINGS</h5>
                            </Col>
                            <hr />
                        </Row>

                        <Tabs
                            activeKey={activeTab}
                            onSelect={(k) => setActiveTab(k)}
                            className="mb-4"
                            fill
                        >
                            <Tab eventKey="notificationImages" title={<span className="fw-semibold">Notification Images</span>}>
                                <Row className="mt-4">
                                    <Col>
                                        <Alert variant="info" className="mb-4">
                                            Manage all notification images used across the platform
                                        </Alert>
                                        <Row>
                                            {settingsData?.notificationImages && Object.entries(settingsData?.notificationImages).map(([key, url]) => (
                                                <Col sm={6} md={4} lg={3} key={key} className="mb-4">
                                                    <Card className="h-100 shadow-sm">
                                                        <Card.Body className="d-flex flex-column">
                                                            <Card.Title className="text-center mb-3">
                                                                <small className="fw-semibold">{imageLabels[key] || key}</small>
                                                                <hr className='mb-0 mt-2' />
                                                            </Card.Title>
                                                            <div className="mb-3 flex-grow-1 d-flex align-items-center justify-content-center">
                                                                <Image src={url} alt={key} fluid className="rounded" style={{ maxHeight: '200px' }} />
                                                            </div>
                                                            <hr className='mt-0' />
                                                            {(systemAccess?.includes("Settings:update") || email === "contact@xpansecafe.com") && (
                                                                <Button 
                                                                    variant="primary" 
                                                                    onClick={() => openImageModal(key)}
                                                                    className="mt-auto"
                                                                >
                                                                    Change Image
                                                                </Button>
                                                            )}
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            ))}
                                        </Row>
                                    </Col>
                                </Row>
                            </Tab>
                            
                            <Tab eventKey="charges" title={<span className='fw-semibold'>Charges & Arrival Time Settings</span>}>
                                <Row className="mt-4">
                                    <Col md={6}>
                                        <Card className="shadow-sm mb-4">
                                            <Card.Header className="bg-primary text-white">
                                                <h5 className="mb-0">Delivery & Packaging Charges</h5>
                                            </Card.Header>
                                            <Card.Body>
                                                <Form onSubmit={handleChargesSubmit}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Delivery Charges</Form.Label>
                                                        <InputGroup>
                                                            <InputGroup.Text>₹</InputGroup.Text>
                                                            <Form.Control 
                                                                type="number" 
                                                                name="deliveryCharges" 
                                                                value={chargesForm?.deliveryCharges} 
                                                                onChange={handleChangeCharges}
                                                                min="0"
                                                                step="0.01"
                                                            />
                                                        </InputGroup>
                                                    </Form.Group>
                                                    
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Packaging Charges</Form.Label>
                                                        <InputGroup>
                                                            <InputGroup.Text>₹</InputGroup.Text>
                                                            <Form.Control 
                                                                type="number" 
                                                                name="packagingCharges" 
                                                                value={chargesForm?.packagingCharges} 
                                                                onChange={handleChangeCharges}
                                                                min="0"
                                                                step="0.01"
                                                            />
                                                        </InputGroup>
                                                    </Form.Group>
                                                    
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Packaging Tax (%)</Form.Label>
                                                        <InputGroup>
                                                            <Form.Control 
                                                                type="number" 
                                                                name="packagingTaxPercent" 
                                                                value={chargesForm?.packagingTaxPercent} 
                                                                onChange={handleChangeCharges}
                                                                min="0"
                                                                max="100"
                                                                step="0.01"
                                                            />
                                                            <InputGroup.Text>%</InputGroup.Text>
                                                        </InputGroup>
                                                    </Form.Group>
                                                    
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Platform Fees</Form.Label>
                                                        <InputGroup>
                                                            <InputGroup.Text>₹</InputGroup.Text>
                                                            <Form.Control 
                                                                type="number" 
                                                                name="platformFees" 
                                                                value={chargesForm?.platformFees} 
                                                                onChange={handleChangeCharges}
                                                                min="0"
                                                                step="0.01"
                                                            />
                                                        </InputGroup>
                                                    </Form.Group>
                                                    
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Platform Tax (%)</Form.Label>
                                                        <InputGroup>
                                                            <Form.Control 
                                                                type="number" 
                                                                name="platformTaxPercent" 
                                                                value={chargesForm?.platformTaxPercent} 
                                                                onChange={handleChangeCharges}
                                                                min="0"
                                                                max="100"
                                                                step="0.01"
                                                            />
                                                            <InputGroup.Text>%</InputGroup.Text>
                                                        </InputGroup>
                                                    </Form.Group>

                                                    {/* ── NEW FIELDS ── */}
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Load Per Order</Form.Label>
                                                        <InputGroup>
                                                            {/* <InputGroup.Text>₹</InputGroup.Text> */}
                                                            <Form.Control
                                                                type="number"
                                                                name="loadPerOrder"
                                                                value={chargesForm?.loadPerOrder}
                                                                onChange={handleChangeCharges}
                                                                min="0"
                                                                step="0.01"
                                                            />
                                                        </InputGroup>
                                                    </Form.Group>

                                                    <Form.Group className="mb-4">
                                                        <Form.Label>Per Item Factor</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            name="perItemFactor"
                                                            value={chargesForm?.perItemFactor}
                                                            onChange={handleChangeCharges}
                                                            min="0"
                                                            step="0.01"
                                                        />
                                                    </Form.Group>
                                                    {/* ── END NEW FIELDS ── */}
                                                    
                                                    <div className="d-grid">
                                                        {(systemAccess?.includes("Settings:update") || email === "contact@xpansecafe.com") && (
                                                            <Button type='submit' variant='success' className='fw-semibold w-50' style={{ justifySelf: 'center' }}>
                                                                { chargesBtnLoading ? <Spinner size='sm' /> : 'Update Charges' }
                                                            </Button>
                                                        )}
                                                    </div>
                                                </Form>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    
                                    <Col md={6}>
                                        <Card className="shadow-sm mb-4">
                                            <Card.Header className="bg-primary text-white">
                                                <h5 className="mb-0">Arrival Time Settings</h5>
                                            </Card.Header>
                                            <Card.Body>
                                                <Form onSubmit={handleArrivalTimeSubmit}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Order Delivery Time (minutes)</Form.Label>
                                                        <Form.Control 
                                                            type="number" 
                                                            name="arrivalTimeSettings" 
                                                            value={arrivalTime?.arrivalTimeSettings} 
                                                            onChange={handleChangeArrivalTime}
                                                            min="0"
                                                        />
                                                    </Form.Group>

                                                    <Form.Group className="mb-4">
                                                        <Form.Label>Order Pickup Time (minutes)</Form.Label>
                                                        <Form.Control 
                                                            type="number" 
                                                            name="orderPickupArrivalTime"
                                                            value={arrivalTime?.orderPickupArrivalTime} 
                                                            onChange={handleChangeArrivalTime}
                                                            min="0"
                                                        />
                                                    </Form.Group>
                                                    
                                                    <div className="d-grid">
                                                        {(systemAccess?.includes("Settings:update") || email === "contact@xpansecafe.com") && (
                                                            <Button variant='success' type='submit' className='fw-semibold w-50' style={{ justifySelf: 'center' }}>
                                                                { ATBtnLoading ? <Spinner size='sm' /> : 'Update Arrival Time'}
                                                            </Button>
                                                        )}
                                                    </div>
                                                </Form>
                                            </Card.Body>
                                        </Card>
                                        <Card className="shadow-sm mb-4">
                                            <Card.Header className="bg-primary text-white">
                                                <h5 className="mb-0">Mode of Order Placement</h5>
                                            </Card.Header>

                                            <Card.Body>
                                                <Form onSubmit={handleOrderModeSubmit}>
                                                <Form.Group className="mb-4">
                                                    <Form.Label className="fw-semibold d-flex align-items-center gap-2">
                                                        <Box size={18} className="text-primary" />
                                                        Self Pickup
                                                    </Form.Label>

                                                    {(systemAccess?.includes("Settings:update") || email === "contact@xpansecafe.com") && (
                                                        <div className="d-flex gap-2">
                                                        {["ACTIVE", "INACTIVE"].map((option) => (
                                                            <Button
                                                                key={option}
                                                                variant={
                                                                    orderModes.selfPickUp === option
                                                                    ? option === "ACTIVE"
                                                                        ? "success"
                                                                        : "danger"
                                                                    : "outline-secondary"
                                                                }
                                                                size="sm"
                                                                onClick={() =>
                                                                    setOrderModes((prev) => ({ ...prev, selfPickUp: option }))
                                                                }
                                                                className="rounded-pill px-4"
                                                            >
                                                                {option}
                                                            </Button>
                                                        ))}
                                                        </div>
                                                    )}
                                                </Form.Group>

                                                <Form.Group className="mb-4">
                                                    <Form.Label className="fw-semibold d-flex align-items-center gap-2">
                                                        <Truck size={20} className="text-danger" />
                                                        Delivery
                                                    </Form.Label>
                                                    <div className="d-flex gap-2">
                                                        {["ACTIVE", "INACTIVE"].map((option) => (
                                                            <Button
                                                                key={option}
                                                                variant={
                                                                    orderModes.delivery === option
                                                                    ? option === "ACTIVE"
                                                                        ? "success"
                                                                        : "danger"
                                                                    : "outline-secondary"
                                                                }
                                                                size="sm"
                                                                onClick={() =>
                                                                    setOrderModes((prev) => ({ ...prev, delivery: option }))
                                                                }
                                                                className="rounded-pill px-4"
                                                            >
                                                                {option}
                                                            </Button>
                                                        ))}
                                                    </div>
                                                </Form.Group>
                                                <div className="d-grid">
                                                    {(systemAccess?.includes("Settings:update") || email === "contact@xpansecafe.com") && (
                                                        <Button variant="success" type="submit" className='fw-semibold w-50' style={{ justifySelf: 'center' }}>
                                                            {orderModeLoading ? <Spinner size="sm" /> : "Update Modes"}
                                                        </Button>
                                                    )}
                                                </div>
                                                </Form>
                                            </Card.Body>
                                        </Card>

                                    </Col>
                                </Row>
                            </Tab>
                            
                            <Tab eventKey="coupons" title={<span className='fw-semibold'>Coupon Settings</span>}>
                                <Row className="mt-4">
                                    <Col>
                                        <Card className="shadow-sm mb-4">
                                            <Card.Header className="bg-success text-white">
                                                <h5 className="mb-0">Coupon Settings</h5>
                                            </Card.Header>
                                            <Card.Body>
                                                <Form onSubmit={handleSubmitCoupon}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className='fw-semibold'>Birthday Coupon</Form.Label>
                                                        <Form.Select 
                                                            id="birthdayCoupon" 
                                                            name="birthdayCoupon" 
                                                            onChange={handleBirthCouponChange} 
                                                            value={settingsData?.couponInfo?.coupon?._id || ''}
                                                        >
                                                            <option value="">Select Birthday Coupon</option>
                                                            {bithdayCouponList?.map((coup) => (
                                                                <option key={coup?._id} value={coup?._id}>
                                                                    {coup?.title}
                                                                </option>
                                                            ))}
                                                        </Form.Select>
                                                    </Form.Group>

                                                    <Form.Group className="mb-3">
                                                        <Form.Label className='fw-semibold'>Referral Coupon</Form.Label>
                                                        <Form.Select 
                                                            name="title" 
                                                            value={settingsData?.referralCoupon?._id} 
                                                            onChange={handleInputChangeReff}
                                                        >
                                                            <option value="">Select Referral Coupon</option>
                                                            {referralCouponList?.map((coup) => (
                                                                <option key={coup?._id} value={coup?._id}>
                                                                    {coup?.title}
                                                                </option>
                                                            ))}
                                                        </Form.Select>
                                                    </Form.Group>

                                                    <Form.Group className="mb-4">
                                                        <Form.Label className='fw-semibold'>WhatsApp Coupon</Form.Label>
                                                        <Form.Select 
                                                            id="whatsAppCoupon" 
                                                            name="whatsAppCoupon" 
                                                            value={settingsData?.whatsAppCoupon?._id} 
                                                            onChange={(e) => handleWhatsAppCouponChange(e.target.value)}
                                                        >
                                                            <option value="">Select WhatsApp Coupon</option>
                                                            {whatsAppCouponList?.map((coup) => (
                                                                <option key={coup?._id} value={coup?._id}>
                                                                    {coup?.title}
                                                                </option>
                                                            ))}
                                                        </Form.Select>
                                                    </Form.Group>
                                                    
                                                    <div className="d-grid">
                                                        {(systemAccess?.includes("Settings:update") || email === "contact@xpansecafe.com") && (
                                                            <Button variant='primary' type='submit'>
                                                                { CouponsBtnLoading ? <Spinner size='sm' /> : "Update Coupon Settings" }
                                                            </Button>
                                                        )}
                                                    </div>
                                                </Form>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </Tab>
                        </Tabs>

                        {/* Image Update Modal */}
                        <Modal show={openUpdateImgModal} onHide={() => setOpenUpdateImgModal(false)} centered>
                            <Modal.Header closeButton>
                                <Modal.Title>Update {imageLabels[currentImageKey] || currentImageKey} Image</Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={handleUpdateImages}>
                                <Modal.Body>
                                    <Form.Group>
                                        <Form.Label>Select New Image (500px width required)</Form.Label>
                                        <Form.Control 
                                            type="file" 
                                            accept="image/*" 
                                            onChange={(e) => handleImageChange(e, currentImageKey)} 
                                        />
                                        {imageError && (
                                            <Alert variant="danger" className="mt-2">
                                                {imageError}
                                            </Alert>
                                        )}
                                    </Form.Group>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => setOpenUpdateImgModal(false)}>
                                        Cancel
                                    </Button>
                                    <Button type='submit' variant='primary' disabled={!!imageError || imageBtnLoading}>
                                        { imageBtnLoading ? <Spinner size='sm' /> : "Save Changes"}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>

                    </div>
                </div>
        </React.Fragment>
    )
}

export default Settings